// XP Pricing Table Accordion
// Ported from WristCo (co-pricing-accordion.js) / WRW (wrw-pricing-accordion.js).
document.addEventListener('click', function(event) {
  var btn = event.target.closest('.xp-pricing-toggle-btn');
  if (!btn) return;
  event.preventDefault();
  event.stopPropagation();
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  btn.nextElementSibling.classList.toggle('open');
});

// Move pricing toggle above "Choose Color(s) & Quantity" on mobile for stock PDPs,
// and back to its original spot on desktop. Re-runs when the viewport crosses the
// 992px breakpoint (DevTools device mode, iPad rotation) so no reload is needed.
var xpPricingMobile = window.matchMedia('(max-width: 992px)');
var xpPricingToggle = null; // { wrapper, parent, next } -- where it was rendered

function moveXpPricingToggle() {
  if (xpPricingToggle && !xpPricingMobile.matches) {
    if (xpPricingToggle.wrapper.parentNode !== xpPricingToggle.parent) {
      xpPricingToggle.parent.insertBefore(xpPricingToggle.wrapper, xpPricingToggle.next);
    }
    return;
  }
  if (!xpPricingMobile.matches) return;

  var colorQuantityDiv = document.querySelector('.four_count_side');
  if (!colorQuantityDiv) return;

  /* snippets/form-product.liquid renders xp-pricing-table up to three
     times on the same page (a responsive desktop/mobile duplicate pair
     via .for-desk/.for__mobile, plus a third copy when the product has no
     color-category metafield) -- unlike WristCo/WRW, which only ever
     render their pricing table once per page. A bare
     ".xp-pricing-toggle-wrapper" query would grab whichever copy appears
     first in the DOM, which on mobile could be a .for-desk copy that's
     actually display:none (confirmed in assets/custom.css: .for__mobile
     is the one shown at <=992px, .for-desk is hidden there). Prefer the
     .for__mobile-scoped wrapper specifically; fall back to a bare query
     for other templates (sections/md-custom-template-product.liquid,
     section-product-customizer-2-hero.liquid) that render this snippet
     without that desktop/mobile duplication at all. */
  /* Found once and remembered: after the move it is no longer inside
     .for__mobile, so re-querying could grab a hidden .for-desk copy. */
  if (!xpPricingToggle) {
    var found =
      document.querySelector('.for__mobile .xp-pricing-toggle-wrapper') ||
      document.querySelector('.xp-pricing-toggle-wrapper');
    if (!found) return;
    xpPricingToggle = { wrapper: found, parent: found.parentNode, next: found.nextSibling };
  }
  var wrapper = xpPricingToggle.wrapper;

  /* Keep the toggle above the donation partner callout (snippets/xp-donation-partner.liquid)
     when one renders between the pricing tables and .four_count_side. */
  var anchor = colorQuantityDiv;
  var donation = colorQuantityDiv.parentNode.querySelector(':scope > .xp-donation-partner');
  if (donation) anchor = donation;

  anchor.parentNode.insertBefore(wrapper, anchor);
}

document.addEventListener('DOMContentLoaded', function () {
  moveXpPricingToggle();
  if (xpPricingMobile.addEventListener) {
    xpPricingMobile.addEventListener('change', moveXpPricingToggle);
  } else if (xpPricingMobile.addListener) {
    xpPricingMobile.addListener(moveXpPricingToggle);
  }
});
